import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useSEO = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // 1. Setează titlul paginii
    document.title = t('seo.title');

    // 2. Actualizează meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('seo.description'));
    }

    // 3. Actualizează meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', t('seo.keywords'));
    }

    // 4. Actualizează Open Graph (pentru distribuiri pe Facebook, WhatsApp, etc.)
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', t('seo.og_title'));

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute('content', t('seo.og_description'));

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', t('seo.twitter_title'));

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) twitterDescription.setAttribute('content', t('seo.twitter_description'));

  }, [i18n.language, t]);
};